var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeyond4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 80,
    viewBox: "0 0 105 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 28.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 51.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 74.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 5.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 28.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 51.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 74.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 5.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 28.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 51.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 74.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.5,
    cy: 5.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.5,
    cy: 28.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.5,
    cy: 51.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.5,
    cy: 74.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.5,
    cy: 5.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.5,
    cy: 28.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.5,
    cy: 51.5,
    r: 5.5,
    fill: "#C1C1E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.5,
    cy: 74.5,
    r: 5.5,
    fill: "#C1C1E9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeyond4);
export default __webpack_public_path__ + "static/media/beyond4.066c6b9f2cad20d91b8c9c9badbf466c.svg";
export { ForwardRef as ReactComponent };